<div class="chips">
  <achoo-chip
    *ngFor="let chip of chips; let inx = index"
    [text]="chip"
    [isProcessing]="isProgressingChip(chip)"
    [isError]="isErrorChip(chip)"
    [removable]="editable"
    [material]="material"
    (remove)="onItemRemove(inx)"
  ></achoo-chip>
  <span *ngIf="errorChips.length > 0" class="has-error-chips">{{'common.mention.error_message' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-chips/achoo-chips.component.html